import { Injectable } from '@angular/core';

@Injectable()
export class HelperService {

    constructor() {}

    //Return the name of a file, withouth extention, from a path 
    //Eg. 
    //Input:http://www.wscprinter.it/business-cards.jpg
    //Output:business-cards
    GetFileNameFromPath(filePath: string) 
    {
        let fileName: string = "";
        
        if(filePath != null)
        {
            let split = filePath.split("/");
            if(split != null)
            {
                let pop = split.pop();

                if(pop != null)
                {
                    fileName = pop.replace(/\.[^/.]+$/, "");
                }
            }

            return fileName;
        }
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/helper.service.ts